import axios from "axios"
import api from "../api"

export const state = {
  entities: [],
  newEntity: '',
  selectedEntity: {name: ''},
  cadences: ['daily', 'weekly', 'none']
}

export const mutations = {
  SET_SETTINGS_STATE (state, {key, data}) {
    state[key] = data
  },
  SET_ENTITIES (state, data) {
    state.entities = data
  },
  SET_SELECTED_ENTITY (state, entity) {
    state.selectedEntity = entity
  },
  ADD_ENTITY (state, data) {
    state.entities.push(data)
  },
  DELETE_ENTITY (state, _id) {
    const index = state.entities.findIndex((obj) => obj._id === _id)
    state.entities.splice(index, 1)
  },
}

export const actions = {
  async get_entities ({commit}) {
    try {
      const { data } = await axios.get(api.entities)
      commit('SET_ENTITIES', data)
    } catch (err) {
      console.log(err)
    }
  },
  async add_entity ({state, commit}) {
    try {
      const { data } = await axios.post(api.entities, {name: state.newEntity})
      commit('ADD_ENTITY', data)
      commit('SET_SETTINGS_STATE', {key: 'newEntity', data: ''})
    } catch (err) {
      console.log(err)
    }
  },
  async update_entity ({state, commit}, {id, payload}) {
    try {
      const url = `/api/entities/${id}`
      await axios.put(url, payload)
    } catch (err) {
      console.log(err)
      commit('SET_D_STATE', {key: 'scraping', data: false})
    }
  },
  async update_entity_details ({state, commit}, {id, payload}) {
    try {
      const url = `/api/entities/cadence/${id}`;
      await axios.put(url, payload);
    } catch (err) {
      console.log(err)
      commit('SET_D_STATE', {key: 'scraping', data: false})
    }
  },
  async delete_entity ({state, commit}, _id) {
    try {
      const url = `${api.entities}/${_id}`
      await axios.delete(url)
      commit('DELETE_ENTITY', _id)
      commit('SET_MODAL', false)
    } catch (err) {
      console.log(err)
      commit('SET_MODAL', false)
    }
  }
}